import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TokenService } from '@app/shared/services/token/token.service';
import { AuthState } from '@app/store/auth/auth.state';
import { Store } from '@ngxs/store';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { environment } from 'environments/environment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-modal-qr-upload-mobile',
  templateUrl: './modal-qr-upload-mobile.component.html',
  styleUrls: ['./modal-qr-upload-mobile.component.sass'],
})
export class ModalQrUploadMobileComponent implements OnInit {
  uploadUrl!: string;
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.LOW;

  constructor(
    private _store: Store,
    private tokenService: TokenService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      idTrade: string;
      model?: string;
      productDivergenceEvidence?: boolean;
      evidences?: any;
      laudo?: boolean;
      token?: string;
      interfaceUi?: 'v1' | 'v2';
      question?: { text: string; answer: string; reason: string };
      questionOrder?: string | number;
    }
  ) {}

  async ngOnInit(): Promise<void> {
    const { token } = await this._store.selectSnapshot(AuthState);
    const result = await this.tokenService
      .save(token, this.data.model === 'ips' ? 'COLLECT.saveToken' : 'COLLECT_TVF.saveToken')
      .pipe(take(1))
      .toPromise();

    const Id = result?.Id ?? result?.id;

    let baseRoute = 'upload/files/triagem';

    if (this.data.interfaceUi === 'v2') {
      baseRoute = 'upload/evidences/screening';
    }

    let url = `${environment.STI_URL}${baseRoute}?t=${this.data.idTrade}&i=${Id}`;

    if (this.data.interfaceUi === 'v2') {
      const params: string[] = [];

      if (this.data.token) {
        params.push(`token=${encodeURIComponent(this.data.token)}`);
      }

      if (this.data.model) {
        params.push(`model=${encodeURIComponent(this.data.model)}`);
      }

      if (this.data.questionOrder !== undefined && this.data.questionOrder !== null) {
        const orderValue = String(this.data.questionOrder).trim();
        if (orderValue !== '') {
          params.push(`o=${encodeURIComponent(orderValue)}`);
        }
      }

      if (this.data.question) {
        try {
          const questionJson = JSON.stringify(this.data.question);
          const safeEncoded = encodeURIComponent(btoa(questionJson));
          params.push(`q=${safeEncoded}`);
        } catch (err) {
          console.error('[v2] Falha ao codificar question para URL:', err);
        }
      }

      if (params.length > 0) {
        url += `&${params.join('&')}`;
      }
    } else {
      if (this.data.model !== 'tvf') {
        this.data.evidences =
          this.data.evidences?.map((evidence: any) => {
            if (evidence.src && evidence.src.trim() !== '') {
              evidence.src = '';
            }
            return evidence;
          }) || [];
      }

      let additionalParams = '';

      if (this.data.model === 'ips') {
        const jsonString = JSON.stringify(this.data.evidences || []);
        const encodedEvidences = encodeURIComponent(
          window.btoa(unescape(encodeURIComponent(jsonString)))
        );
        additionalParams = `&model=ips&ips=true&evidences=${encodedEvidences}&laudo=true&token=${this.data.token || ''}`;
      } else {
        additionalParams = `&token=${this.data.token || ''}`;
      }

      url += additionalParams;
    }

    if (this.data.productDivergenceEvidence) {
      url += '&productDivergenceEvidence=true';
    }

    this.uploadUrl = url;
    console.log('URL do QR Code de upload:', this.uploadUrl);
  }
}
